import { Pipe, PipeTransform } from "@angular/core";
import { METERS_IN_FOOT, METERS_IN_KILOMETER } from "./length";

@Pipe({
    name: "convertToFeet",
})
export class ConvertToFeetPipe implements PipeTransform {
    public transform(value: number | undefined | null, from: "meters" | "kilometers" = "meters"): number | undefined {
        if (value === undefined || value === null) {
            return undefined;
        }

        if (from === "kilometers") {
            return (value * METERS_IN_KILOMETER) / METERS_IN_FOOT;
        }

        return value / METERS_IN_FOOT;
    }
}
